import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { UserModal } from "./components/UserModal";
import { useUserStore } from "../../hooks/UseUserStore";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { UserDetailModal } from "./components/UserDetailModal";
import { readLocalStorage } from "../../toolbox/helpers/local-storage-helpers";
import { LocalStorageKey } from "../../types";
import { Role } from "../../types/roles/roleTypes";
import { maskRUT } from "../../toolbox/helpers/rut-helper";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'rut', label: 'RUT', align: 'center', format: (row) => maskRUT(row.rut) },
    { type: 'text', field: 'username', label: 'Username', align: 'center' },
    { type: 'text', field: 'userType', label: 'Tipo de usuario', align: 'center' },
    { type: 'text', field: 'email', label: 'Email', align: 'center' },
    { type: 'text', field: 'supplier', label: 'Cliente', align: 'center' },
    { type: 'text', field: 'supplier_rut', label: 'RUT Cliente', align: 'center' },
    // { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    // { type: 'text', field: 'first_surname', label: 'Appelido', align:'center' },
    // { type: 'text', field: 'privilege', label: 'privilegio', align:'center' },
];

export const UsersView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionUser, getUsers, getUsersByCompany, deleteUser } = useUserStore();

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const role = userData?.userType || '';

    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [showModalDetail, setShowModalDetail] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getUsersApi()
    }, [])

    const getUsersApi = async (search = '') => {
        try {
            setLoading(true);
            const response = (role && role == Role.SUPER_ADMIN) ? await getUsers(search) : await getUsersByCompany(search);
            if (!response) {
                setUsers([]); setLoading(false);
                return false;
            } else {
                setUsers(response);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionUser('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected: any) => {
        setActionUser('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected: any) => {
        setActionUser('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected: any) => {
        setActionUser('detail');
        setRowSelected(rowSelected);
        setShowModalDetail(true);
    }
    const onSwitch = () => {

    }

    const onDeleteConfirm = async () => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteUser(rowSelected.id)
            if (response) {
                getUsersApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            } else {
                setLoading(false);
                return false;
            }
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getUsersApi(term) }, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable
                    title={'Usuarios'}
                    columns={columns}
                    loading={loading}
                    rows={users || []}
                    onRowClick={() => { }}
                    hasOptions
                    onAddFn={onAdd}
                    onAddFnName={'Nuevo usuario'}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onSearch={onSearch}
                    dense
                />
            </Grid>
            {
                showModal && (
                    <UserModal
                        open={showModal}
                        closeModal={() => { setShowModal(false) }}
                        userSelected={rowSelected}
                        listUser={getUsersApi}
                        clearState={clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={() => { setShowModalConfirm(false); clearState() }}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
            {
                showModalDetail && (
                    <UserDetailModal
                        open={showModalDetail}
                        closeModal={() => { setShowModalDetail(false); clearState(); getUsersApi() }}
                        userSelected={rowSelected}
                        clearState={clearState}
                    />
                )
            }
        </>
    )
}